"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsAvatarLoadingSelector = exports.settingsAvatarSelector = exports.selectDeveloper = exports.settingsLoadingSelector = exports.settingsSelector = exports.removeDeveloperMedia = exports.uploadDeveloperMediaFailure = exports.uploadDeveloperMediaSuccess = exports.uploadingDeveloperMedia = exports.removeAvatarFailure = exports.removeAvatarSuccess = exports.removingAvatar = exports.uploadAvatarFailure = exports.uploadAvatarSuccess = exports.uploadingAvatar = exports.deactivateFailure = exports.deactivateSuccess = exports.deactivating = exports.updateProfileFailure = exports.updateProfileSuccess = exports.updatingProfile = exports.fetchProfileFailure = exports.fetchProfileSuccess = exports.fetchingProfile = exports.removeDeveloperProject = exports.removeMedia = exports.uploadMedia = exports.deleteAvatar = exports.uploadAvatar = exports.deactivate = exports.updateProfile = exports.getProfile = exports.settingsSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var humps_1 = __importDefault(require("humps"));
var auth = __importStar(require("../../helpers/auth"));
var uri_1 = require("../../helpers/uri");
var loginSlice_1 = require("../login/loginSlice");
var userSlice_1 = require("../user/userSlice");
var initialState = {
    loading: false,
    avatarLoading: false,
    data: undefined,
    mediaLoading: false,
};
exports.settingsSlice = toolkit_1.createSlice({
    name: 'settings',
    initialState: initialState,
    reducers: {
        fetchingProfile: function (state) {
            state.loading = true;
        },
        fetchProfileSuccess: function (state, action) {
            state.loading = false;
            state.data = action.payload;
        },
        fetchProfileFailure: function (state) {
            state.loading = false;
        },
        updatingProfile: function (state) {
            state.loading = true;
        },
        updateProfileSuccess: function (state, action) {
            state.loading = false;
            state.data = action.payload;
        },
        updateProfileFailure: function (state) {
            state.loading = false;
        },
        deactivating: function (state) {
            state.loading = true;
        },
        deactivateSuccess: function (state) {
            state.loading = false;
        },
        deactivateFailure: function (state) {
            state.loading = false;
        },
        uploadingAvatar: function (state) {
            state.avatarLoading = true;
        },
        uploadAvatarSuccess: function (state, action) {
            state.avatarLoading = false;
            state.data.avatar = action.payload;
        },
        uploadAvatarFailure: function (state) {
            state.avatarLoading = false;
        },
        removingAvatar: function (state) {
            state.avatarLoading = true;
        },
        removeAvatarSuccess: function (state) {
            state.avatarLoading = false;
            state.data.avatar = '';
        },
        removeAvatarFailure: function (state) {
            state.avatarLoading = false;
        },
        uploadingDeveloperMedia: function (state) {
            state.mediaLoading = true;
        },
        uploadDeveloperMediaSuccess: function (state, action) {
            state.mediaLoading = false;
            state.data.developers[0].developerMedia = action.payload;
        },
        uploadDeveloperMediaFailure: function (state) {
            state.mediaLoading = false;
        },
        removeDeveloperMedia: function (state, action) {
            state.data.developers[0].developerMedia =
                state.data.developers[0].developerMedia.filter(function (item) { return item.id !== action.payload.id; });
        },
    },
});
var getProfile = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, camelized, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingProfile());
                    return [4 /*yield*/, axios_1.default.get('/api/profile')];
                case 1:
                    data = (_a.sent()).data;
                    camelized = humps_1.default.camelizeKeys(data);
                    dispatch(exports.fetchProfileSuccess(camelized));
                    return [2 /*return*/, camelized];
                case 2:
                    e_1 = _a.sent();
                    dispatch(exports.fetchProfileFailure());
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getProfile = getProfile;
var updateProfile = function (payload) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, _a, accessToken, user, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch(exports.updatingProfile());
                    if (payload.contacts.length === 1 && !payload.contacts[0].phone) {
                        delete payload.contacts;
                    }
                    return [4 /*yield*/, axios_1.default.put('/api/profile', humps_1.default.decamelizeKeys(payload))];
                case 1:
                    data = (_b.sent()).data;
                    _a = humps_1.default.camelizeKeys(data), accessToken = _a.accessToken, user = _a.user;
                    if (accessToken) {
                        auth.setToken(accessToken);
                    }
                    dispatch(exports.updateProfileSuccess(user));
                    return [2 /*return*/, user];
                case 2:
                    e_2 = _b.sent();
                    dispatch(exports.updateProfileFailure());
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.updateProfile = updateProfile;
var deactivate = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.deactivating());
                    return [4 /*yield*/, axios_1.default.post('/api/profile/deactivate')];
                case 1:
                    _a.sent();
                    auth.removeToken();
                    dispatch(userSlice_1.removeUser());
                    dispatch(loginSlice_1.logoutSuccess());
                    dispatch(exports.deactivateSuccess());
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    dispatch(exports.deactivateFailure());
                    throw e_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.deactivate = deactivate;
var uploadAvatar = function (base64) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var blob, formData, data, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.uploadingAvatar());
                    blob = uri_1.dataUritoBlob(base64);
                    formData = new FormData();
                    formData.append('avatar', blob);
                    return [4 /*yield*/, axios_1.default.post('/api/profile/avatar', formData, {
                            headers: {
                                'content-type': 'multipart/form-data',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(userSlice_1.setUserAvatar({ avatar: data.path }));
                    dispatch(exports.uploadAvatarSuccess(data.path));
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    dispatch(exports.uploadAvatarFailure());
                    throw e_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.uploadAvatar = uploadAvatar;
var deleteAvatar = function (userId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.removingAvatar());
                    return [4 /*yield*/, axios_1.default.delete('/api/profile/avatar', {
                            params: {
                                id: userId,
                            },
                        })];
                case 1:
                    _a.sent();
                    dispatch(exports.removeAvatarSuccess());
                    dispatch(userSlice_1.removeUserAvatar());
                    return [3 /*break*/, 3];
                case 2:
                    e_5 = _a.sent();
                    dispatch(exports.removeAvatarFailure());
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.deleteAvatar = deleteAvatar;
var uploadMedia = function (files) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var media_1, data, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.uploadingDeveloperMedia());
                    media_1 = new FormData();
                    files.forEach(function (f) {
                        media_1.append('media[]', f);
                    });
                    return [4 /*yield*/, axios_1.default.post("/api/profile/developer-media", media_1, {
                            headers: {
                                'content-type': 'multipart/form-data',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data.data;
                    dispatch(exports.uploadDeveloperMediaSuccess(data));
                    dispatch(userSlice_1.uploadUserSliceDeveloperMedia(data));
                    return [2 /*return*/, data];
                case 2:
                    e_6 = _a.sent();
                    dispatch(exports.uploadDeveloperMediaFailure());
                    throw e_6;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.uploadMedia = uploadMedia;
var removeMedia = function (id) {
    return function (dispatch) {
        try {
            axios_1.default.delete('/api/profile/developer-media', {
                params: {
                    id: id,
                },
            });
            dispatch(exports.removeDeveloperMedia({ id: id }));
            dispatch(userSlice_1.removeUserSliceDeveloperMedia({ id: id }));
        }
        catch (e) {
            throw e;
        }
    };
};
exports.removeMedia = removeMedia;
var removeDeveloperProject = function (id) {
    return function () {
        try {
            axios_1.default.delete('/api/profile/developer-project', {
                params: {
                    id: id,
                },
            });
        }
        catch (e) {
            throw e;
        }
    };
};
exports.removeDeveloperProject = removeDeveloperProject;
exports.fetchingProfile = (_a = exports.settingsSlice.actions, _a.fetchingProfile), exports.fetchProfileSuccess = _a.fetchProfileSuccess, exports.fetchProfileFailure = _a.fetchProfileFailure, exports.updatingProfile = _a.updatingProfile, exports.updateProfileSuccess = _a.updateProfileSuccess, exports.updateProfileFailure = _a.updateProfileFailure, exports.deactivating = _a.deactivating, exports.deactivateSuccess = _a.deactivateSuccess, exports.deactivateFailure = _a.deactivateFailure, exports.uploadingAvatar = _a.uploadingAvatar, exports.uploadAvatarSuccess = _a.uploadAvatarSuccess, exports.uploadAvatarFailure = _a.uploadAvatarFailure, exports.removingAvatar = _a.removingAvatar, exports.removeAvatarSuccess = _a.removeAvatarSuccess, exports.removeAvatarFailure = _a.removeAvatarFailure, exports.uploadingDeveloperMedia = _a.uploadingDeveloperMedia, exports.uploadDeveloperMediaSuccess = _a.uploadDeveloperMediaSuccess, exports.uploadDeveloperMediaFailure = _a.uploadDeveloperMediaFailure, exports.removeDeveloperMedia = _a.removeDeveloperMedia;
var settingsSelector = function (state) {
    if (!state.settings.data) {
        return;
    }
    var data = __assign({}, (state.settings.data || {}));
    if (!data.contacts || !data.contacts.length) {
        data.contacts = undefined;
        return data;
    }
    return data;
};
exports.settingsSelector = settingsSelector;
var settingsLoadingSelector = function (state) {
    return state.settings.loading;
};
exports.settingsLoadingSelector = settingsLoadingSelector;
var selectDeveloper = function (state) {
    var settings = exports.settingsSelector(state);
    if (!settings) {
        return {};
    }
    if (settings.developers.length) {
        return settings.developers[0];
    }
    return {};
};
exports.selectDeveloper = selectDeveloper;
var settingsAvatarSelector = function (state) { var _a; return (_a = state.settings.data) === null || _a === void 0 ? void 0 : _a.avatar; };
exports.settingsAvatarSelector = settingsAvatarSelector;
var settingsAvatarLoadingSelector = function (state) {
    return state.settings.avatarLoading;
};
exports.settingsAvatarLoadingSelector = settingsAvatarLoadingSelector;
exports.default = exports.settingsSlice.reducer;
